import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import classBind from 'classnames/bind';

import styles from './styles.scss';

let cx = classBind.bind(styles);

class Button extends Component {
  constructor(props) {
    super(props);

    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick(e) {
    const { fieldValue, input } = this.props;

    if (input && input.onChange) {
      input.onChange(fieldValue);
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }

  render() {
    var type = this.props.type || 'button';
    var style = this.props.variant ?? this.props.style;
    var block = this.props.block;

    const buttonType = type === 'submit' ? 'submit' : 'button';

    let className = cx({
      button: true,
      [`${style}`]: true,
      [`${type}`]: true,
      block: block,
    });

    if (this.props.to) {
      return (
        <Link
          className={classnames(className)}
          to={this.props.to}
          type={buttonType}
          disabled={this.props.disabled}
        >
          {this.props.buttonText}
        </Link>
      );
    }

    return (
      <button
        className={classnames(className)}
        onClick={this.handleOnClick}
        type={buttonType}
        disabled={this.props.disabled}
      >
        {this.props.buttonText}
      </button>
    );
  }
}

Button.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.string,
  to: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    style: state.configuration.style,
  };
};

export default connect(mapStateToProps)(Button);
